import * as React from "react"
import Popover from "@mui/material/Popover"
import { Box, IconButton } from "@mui/material"
import { FaLaugh } from "react-icons/fa"
import EmojiPicker from "emoji-picker-react"
import { useTranslation } from "react-i18next"
import { styles } from "./EmojiPicker.styles"

const emojiSize = "18px"
const emojiSizeMultiplier = 1.5
const emojiPerRow = 9

export default function MyEmojiPicker({ onEmojiSelected }) {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? "simple-popover" : undefined

  const onEmojiClick = (emojiData, event) => {
    if (onEmojiSelected) {
      onEmojiSelected(emojiData?.emoji || "")
    }
    handleClose()
  }

  return (
    <Box sx={styles.main}>
      <IconButton aria-describedby={id} onClick={handleClick} color="warning">
        <FaLaugh />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={styles.main}
      >
        <EmojiPicker
          theme="auto"
          emojiStyle="native"
          lazyLoadEmojis
          searchPlaceholder={t("search_emojis")}
          width={`calc(${emojiPerRow} * ${emojiSize} * ${emojiSizeMultiplier} + 1em + 1.5rem)`}
          height={300}
          onEmojiClick={onEmojiClick}
          previewConfig={{
            showPreview: false,
          }}
        />
      </Popover>
    </Box>
  )
}
